import { call, put, takeLatest } from 'redux-saga/effects';
import Email from '../../api/email';
import { actionTypes, getEmailByIdSuccess, getEmailsSuccess } from '../actions/email';

function* createEmail(action) {
  try {
    const result = yield call(() => Email.createEmail(action.payload));
    action.callback(result);
  } catch (error) {
    console.log(error);
    action.callback(null, error?.response?.data?.message);
  }
}

function* getEmails(action) {
  try {
    const result = yield call(() => Email.getEmails(action.payload));
    yield put(getEmailsSuccess(result));
    action.callback(true);
  } catch (error) {
    console.log(error);
    action.callback(false, error?.response?.data?.message);
  }
}

function* getEmailById(action) {
  try {
    const result = yield call(() => Email.getEmailById(action.payload));
    yield put(getEmailByIdSuccess(result));
    action.callback(result);
  } catch (error) {
    console.log(error);
    action.callback(null, error?.response?.data?.message);
  }
}

function* getEmailByParams(action) {
  try {
    const result = yield call(() => Email.getEmailByParams(action.payload));
    action.callback(result);
  } catch (error) {
    console.log(error);
  }
}

function* updateEmail(action) {
  try {
    const result = yield call(() => Email.updateEmail(action.payload.id, action.payload));
    action.callback(result);
  } catch (error) {
    console.log(error);
    action.callback(null, error?.response?.data?.message);
  }
}

function* sendEmail(action) {
  try {
    const result = yield call(() => Email.sendEmail(action.payload));
    action.callback(result);
  } catch (error) {
    console.log(error);
    action.callback(null, error?.response?.data?.message);
  }
}

function* sendTestEmail(action) {
  try {
    yield call(() => Email.sendTestEmail(action.payload));
    action.callback(true);
  } catch (error) {
    console.log(error);
    action.callback(null, error?.response?.data?.message);
  }
}

function* resetEmail() {
  try {
    yield put(getEmailByIdSuccess({}));
  } catch (error) {
    console.log(error);
  }
}

export default function* emailSaga() {
  yield takeLatest(actionTypes.CREATE_EMAIL, createEmail);
  yield takeLatest(actionTypes.GET_EMAILS, getEmails);
  yield takeLatest(actionTypes.GET_EMAIL_BY_ID, getEmailById);
  yield takeLatest(actionTypes.GET_EMAIL_BY_PARAMS, getEmailByParams);
  yield takeLatest(actionTypes.UPDATE_EMAIL, updateEmail);
  yield takeLatest(actionTypes.SEND_EMAIL, sendEmail);
  yield takeLatest(actionTypes.SEND_TEST_EMAIL, sendTestEmail);
  yield takeLatest(actionTypes.RESET_EMAIL, resetEmail);
}
